import { render, staticRenderFns } from "./ScreenStaff.vue?vue&type=template&id=3e9748e7&scoped=true&"
import script from "./ScreenStaff.vue?vue&type=script&lang=js&"
export * from "./ScreenStaff.vue?vue&type=script&lang=js&"
import style0 from "./ScreenStaff.vue?vue&type=style&index=0&id=3e9748e7&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e9748e7",
  null
  
)

export default component.exports